<template>
  <div
    v-if="loaded"
    class="settings-section"
    data-testid="pricing-history-section"
  >
    <h4 class="section-title">{{ t('Histórico de preços publicados') }}</h4>
    <p class="section-subtitle">
      {{ t('Toda taxa já publicada, da mais recente para a mais antiga. Somente leitura.') }}
    </p>
    <data-table
      :config="datatableConfig"
      :data="pricingHistory"
      :refreshButton="{ show: true }"
      data-testid="pricing-history-table"
      @refresh="fetchHistory"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAiSettings } from '../../../composables/useAiSettings'
import { log } from '../../../utils/DebugLogger'

const { t } = useI18n()
const { pricingHistory, loadPricingHistory } = useAiSettings()

const loaded = ref(false)

async function fetchHistory(): Promise<void> {
  try {
    await loadPricingHistory()
  } catch (err) {
    log('PricingHistoryTable', 'fetchHistory', 'Erro ao carregar histórico', err)
  } finally {
    loaded.value = true
  }
}

const tableColumns = computed(() => [
  { data: 'model_name', title: t('Modelo') },
  { data: 'cache_hit_usd_per_1m', title: t('cache_hit USD/1M') },
  { data: 'cache_miss_usd_per_1m', title: t('cache_miss USD/1M') },
  { data: 'output_usd_per_1m', title: t('output USD/1M') },
  { data: 'valid_from', title: t('Em vigor desde'), renderType: 'datetime' },
  {
    data: 'valid_to',
    title: t('Situação'),
    renderType: 'badge',
    badgeConfig: (row: Record<string, unknown>) => {
      const inForce = row.valid_to == null
      return {
        label: inForce ? t('Em vigor') : t('Substituída'),
        severity: inForce ? 'success' : 'secondary',
      }
    },
  },
])

const datatableConfig = computed(() => ({
  tableId: 'pricingHistoryTable',
  columns: tableColumns.value,
  pagination: true,
  pageLength: 25,
}))

onMounted(fetchHistory)

defineExpose({ fetchHistory })
</script>

<style scoped>
.settings-section {
  background: var(--p-surface-0, #fff);
  border: 1px solid var(--p-surface-200, #e5e7eb);
  border-radius: 8px;
  padding: 20px;
  margin-top: 20px;
}

.section-title {
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--p-text-color);
}

.section-subtitle {
  margin: 0 0 16px 0;
  font-size: 13px;
  color: var(--p-text-muted-color, #6b7280);
}
</style>
